"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
let BatchDeleteVD = class extends Mixins(AccountSessionMixins) {
  get show() {
    var _a;
    for (let item of this._controller.selected) {
      if (!item.marks.is("IS_ADMIN")) {
        return false;
      }
      if (item.marks.is("NOT_ALLOW_DEL")) {
        return false;
      }
    }
    if (this._controller.query.filter.group === "vdgroup_system_recycle" && !((_a = this.$session) == null ? void 0 : _a.marks.is("ALLOW_DELETE_VD_IN_RECYCLE"))) {
      return false;
    }
    return true;
  }
  releaseVD() {
    return __async(this, null, function* () {
      var _a;
      if (this._controller.query.filter.group === "vdgroup_system_recycle" && ((_a = this.$session) == null ? void 0 : _a.marks.is("ALLOW_DELETE_VD_IN_RECYCLE"))) {
        this.$emit("realDeleteVD", this._controller.selected);
      } else {
        this.$emit("deleteVd", this._controller.selected);
      }
    });
  }
};
__decorateClass([
  PropSync("controller")
], BatchDeleteVD.prototype, "_controller", 2);
BatchDeleteVD = __decorateClass([
  Component({
    components: {}
  })
], BatchDeleteVD);
export {
  BatchDeleteVD as default
};
